module.exports = __webpack_public_path__ + "static/9-98950e9bbb53ccc65802010a8a21554b.jpg";